exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-swiper[data-v-39c495dc]{position:relative;overflow:hidden}.m-swiper .indicator[data-v-39c495dc]{position:absolute;right:16px;bottom:8px;padding:0 12px;height:24px;line-height:24px;border-radius:50px;text-align:center;background:rgba(0,0,0,.5);color:#fff;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39c495dc","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/lib/swiper/Swiper.vue
// module id = 8
// module chunks = 0